import { gql } from "@apollo/client";

const wishlistFragment = gql`
    fragment WishlistItem on WishlistSparePart {
        id
        quantity
        article {
            id
            name(languageCode: $languageCode)
            articleNumber
            assetPath
        }
        model {
            id
            description
            articleNumber
            year
            brand {
                id
                name
                shortName
            }
            modelSpecifications {
                id
                name
            }
        }
    }
`;

export const wishlistQuery = gql`
    query Wishlist($spareParts: [SparePartModel!]!, $languageCode: String) {
        wishlist(spareParts: $spareParts) {
            nodes {
                ...WishlistItem
            }
            totalCount
        }
    }
    ${wishlistFragment}
`;
